export const PRIVATE = 'private';
export const ORGANIZATION = 'organization';
export const SECRET = 'secret';
export const PUBLIC = 'public';

export const DEFAULT_PRIVACY = PRIVATE;
export const PRIVACY_OPTIONS = [PRIVATE, SECRET, PUBLIC];
export const SCHOOL_PRIVACY_OPTIONS = [PRIVATE, ORGANIZATION, SECRET, PUBLIC];

export const READ = 'read';
export const CREATE = 'create';
export const EDIT = 'edit';
export const ADMIN = 'administrator';

export const DEFAULT_PERMISSION = READ;
export const PERMISSION_OPTIONS = [READ, EDIT, ADMIN];
export const GLOBAL_PERMISSION_OPTIONS = [READ, CREATE];

export const ANSWER_TYPES = ['SINGLE', 'MULTIPLE', 'HANGMAN', 'FREETEXT', 'NUMERIC', 'RANGE'];
export const DEFAULT_ANSWER_TYPE = 'SINGLE';
export const EMPTY_ANSWER_TYPE = 'EMPTY';

export const DEFAULT_TRIGGERS = ['NEXT', 'GO_TO_POINT', 'END'];
export const ANSWER_TRIGGERS = ['ON_ANSWER'];
export const LOCATION_TRIGGERS = ['AT_ARRIVE'];

export const COURSE_TYPE_NOOC = 'nooc';
export const COURSE_TYPE_WEBINAR = 'webinar';
export const COURSE_TYPE_COACHING = 'coaching';
export const COURSE_TYPE_TOOLS = 'tools';

export const ACTIVITY_TYPE_BOOK_EXTENSION = 'book_extension';
export const ACTIVITY_TYPE_GLOBAL_PROJECT = 'global_project';

export const BAIN_SOCIAL_IMPACT_TAGS = [
    {
        value: 'inclusion',
        category: 'social-impact',
    },
    {
        value: 'change-agent',
        category: 'social-impact',
    },
];

export const BAIN_LIFE_CHANGER_TAGS = [
    {
        value: 'family',
        category: 'life-changer',
    },
    {
        value: 'heritage',
        category: 'life-changer',
    },
    {
        value: 'self-realization',
        category: 'life-changer',
    },
    {
        value: 'motivation',
        category: 'life-changer',
    },
];

export const BAIN_EMOTIONAL_TAGS = [
    {
        value: 'wellbeing',
        category: 'emotional',
    },
    {
        value: 'fun',
        category: 'emotional',
    },
    {
        value: 'distinctive',
        category: 'emotional',
    },
    {
        value: 'reward',
        category: 'emotional',
    },
    {
        value: 'attractive',
        category: 'emotional',
    },
    {
        value: 'significant',
        category: 'emotional',
    },
];

export const BAIN_FUNCTIONAL_TAGS = [
    {
        value: 'connect',
        category: 'functional',
    },
    {
        value: 'organizes',
        category: 'functional',
    },
    {
        value: 'integration',
        category: 'functional',
    },
    {
        value: 'timesaver',
        category: 'functional',
    },
    {
        value: 'variety',
        category: 'functional',
    },
    {
        value: 'informs',
        category: 'functional',
    },
    {
        value: 'step-by-step',
        category: 'functional',
    },
];

export const BAIN_TAGS = [
    ...BAIN_EMOTIONAL_TAGS,
    ...BAIN_FUNCTIONAL_TAGS,
    ...BAIN_LIFE_CHANGER_TAGS,
    ...BAIN_SOCIAL_IMPACT_TAGS,
];

export const AVAILIABLE_IMPORT_ENVIRONMENTS = [
    {
        name: 'eduloc',
        url: 'http://www.eduloc.net',
        image: '/img/eduloc.png',
        admin: false
    },
    /*{
        name: 'dev.eduloc',
        url: 'http://dev.eduloc.net',
        image: '/img/dev-eduloc.png',
        admin: false
    },*/
    /*{
        name: 'develop.labylok',
        url: 'https://develop.labylok.com',
        image: '/img/dev-labylok.jpg',
        admin: true
    },*/
    {
        name: 'labylok',
        url: 'https://www.labylok.com',
        image: '/img/prod-labylok.jpg',
        admin: false
    },
    {
        name: 'eduloc360',
        url: 'https://eduloc360.com',
        image: '/img/eduloc360-prod.jpg',
        admin: true
    },
    {
        name: 'dev.eduloc360',
        url: 'https://int-crea.eduloc360.com',
        image: '/img/eduloc360-DEV.jpg',
        admin: false
    },
];

export const TILE_PROVIDERS = [
    {
        name: 'OpenStreetMap',
        visible: false,
        type: 'base',
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        image: 'osm.png',
        options: { maxNativeZoom: 24, maxZoom: 24 },
        needWays: false
    },
    {
        name: 'OpenStreetMap 2',
        visible: false,
        type: 'base',
        url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
        attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>',
        image: 'otm.png',
        options: { maxNativeZoom: 20, maxZoom: 24 },
        needWays: false
    },
    /*{
        name: 'Stadia Stamen Terrrain',
        visible: false,
        type: 'base',
        url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
        attribution:
            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        image: 'stamen_terrain.png',
        options: { maxNativeZoom: 22, maxZoom: 24 }
    },*/
    /*{
        name: 'CartoDB Voyager',
        visible: false,
        type: 'base',
        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png',
        attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        image: 'stamen_terrain.png',
        options: { maxNativeZoom: 24, maxZoom: 24 },
        needWays: false
    },*/
    {
        name: 'ERSI street',
        visible: false,
        type: 'base',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
        image: 'ersi_street.png',
        options: { maxNativeZoom: 19, maxZoom: 24 },
        needWays: false
    },
    {
        name: 'ERSI topo',
        visible: false,
        type: 'base',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        attribution:
            'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
        image: 'ersi_topo.png',
        options: { maxNativeZoom: 19, maxZoom: 24 },
        needWays: false
    },
    {
        name: 'ERSI photo',
        visible: false,
        type: 'base',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        image: 'ersi_photo.png',
        options: { maxNativeZoom: 19, maxZoom: 24 },
        needWays: true
    },
    /*{
        name: 'Positron',
        visible: false,
        type: 'base',
        url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
        image: 'positron.png',
        options: { maxNativeZoom: 24, maxZoom: 24 },
        needWays: false
    },*/
    {
        name: 'Google test',
        visible: false,
        type: 'base',
        url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    },
    {
        name: 'map_names',
        visible: true,
        type: 'overlay',
        url: 'https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png',
        attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        options: { maxZoom: 24 }
    },

];

export const ICGC_WMS_LAYERS = [
    {
        url: "https://geoserveis.icgc.cat/servei/catalunya/orto-territorial/wms",
        name: 'ICGC TOPO 1945',
        visible: true,
        format: 'image/jpeg',
        layers: 'ortofoto_blanc_i_negre_1945',
        transparent: true,
        version: '1.3.0',
        attribution: '© ICGC',
        options: { maxNativeZoom: 18, maxZoom: 24 }
    }
];

export const DEFAULT_TILE_PROVIDER = {
    name: 'ERSI photo',
    visible: true,
    type: 'base',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution:
        'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    image: 'ersi_photo.png',
    options: { maxNativeZoom: 18, maxZoom: 24 }

};

export const ADMIN_FILTER_PROJECT_TYPES = [
    "PROJECT_TYPE_WALL",
    "PROJECT_TYPE_MAP",
    "PROJECT_TYPE_QUIZ",
    "PROJECT_TYPE_QUIZHUNT",
    "PROJECT_TYPE_GEOQUIZ",
    "PROJECT_TYPE_STORYTELLING",
    "PROJECT_TYPE_TIMEMACHINE",
    "PROJECT_TYPE_TREASUREHUNT",
    "PROJECT_TYPE_SCAPE",
    "PROJECT_TYPE_MEMORY"
];

export const USER_FILTER_PROJECT_TYPES = [
    "PROJECT_TYPE_WALL",
    "PROJECT_TYPE_MAP",
    "PROJECT_TYPE_QUIZ",
    "PROJECT_TYPE_QUIZHUNT",
    "PROJECT_TYPE_GEOQUIZ",
    "PROJECT_TYPE_TREASUREHUNT",
];

export const FILTER_PROJECT_TYPES = [
    "PROJECT_TYPE_ALL",
    "PROJECT_TYPE_WALL",
    "PROJECT_TYPE_MAP",
    "PROJECT_TYPE_QUIZ",
    "PROJECT_TYPE_QUIZHUNT",
    "PROJECT_TYPE_GEOQUIZ",
    "PROJECT_TYPE_TREASUREHUNT",
    "PROJECT_TYPE_MEMORY",
];

export const TREASUREHUNT_OBJECT_TYPES = ["object", "clue", "question"];
export const TREASUREHUNT_DEFAULT_TRIGGER = "NEXT";
export const TREASUREHUNT_OBJECT_TRIGGER = "NEXT";
export const TREASUREHUNT_QUESTION_TRIGGER = "ON_ANSWER";
export const TREASUREHUNT_CLUE_TRIGGER = "AT_ARRIVE";

export const POINTS_DEFAULT = [
    {
        label: "points_0",
        value: 0
    },
    {
        label: "points_5",
        value: 5
    },
    {
        label: "points_10",
        value: 10
    },
    {
        label: "points_15",
        value: 15
    },
    {
        label: "points_20",
        value: 20
    },
    {
        label: "points_25",
        value: 25
    },
    {
        label: "points_50",
        value: 50
    },
    {
        label: "points_100",
        value: 100
    }
]

export const AVAILIABLE_PROJECT_TYPES = [
    "PROJECT_TYPE_WALL",
    "PROJECT_TYPE_MAP",
    "PROJECT_TYPE_QUIZ",
    "PROJECT_TYPE_QUIZHUNT",
    "PROJECT_TYPE_GEOQUIZ",
    "PROJECT_TYPE_TREASUREHUNT",
    "PROJECT_TYPE_MEMORY",
];

export const ALL_LANG_CODES = [
    'aa',
    'ab',
    'ae',
    'af',
    'ak',
    'am',
    'an',
    'ar',
    'as',
    'av',
    'ay',
    'az',
    'ba',
    'be',
    'bg',
    'bh',
    'bi',
    'bm',
    'bn',
    'bo',
    'br',
    'bs',
    'ca',
    'ce',
    'ch',
    'co',
    'cr',
    'cs',
    'cu',
    'cv',
    'cy',
    'da',
    'de',
    'dv',
    'dz',
    'ee',
    'el',
    'en',
    'eo',
    'es',
    'et',
    'eu',
    'fa',
    'ff',
    'fi',
    'fj',
    'fo',
    'fr',
    'fy',
    'ga',
    'gd',
    'gl',
    'gn',
    'gu',
    'gv',
    'ha',
    'he',
    'hi',
    'ho',
    'hr',
    'ht',
    'hu',
    'hy',
    'hz',
    'ia',
    'id',
    'ie',
    'ig',
    'ii',
    'ik',
    'io',
    'is',
    'it',
    'iu',
    'ja',
    'jv',
    'ka',
    'kg',
    'ki',
    'kj',
    'kk',
    'kl',
    'km',
    'kn',
    'ko',
    'kr',
    'ks',
    'ku',
    'kv',
    'kw',
    'ky',
    'la',
    'lb',
    'lg',
    'li',
    'ln',
    'lo',
    'lt',
    'lu',
    'lv',
    'mg',
    'mh',
    'mi',
    'mk',
    'ml',
    'mn',
    'mr',
    'ms',
    'mt',
    'my',
    'na',
    'nb',
    'nd',
    'ne',
    'ng',
    'nl',
    'nn',
    'no',
    'nr',
    'nv',
    'ny',
    'oc',
    'oj',
    'om',
    'or',
    'os',
    'pa',
    'pi',
    'pl',
    'ps',
    'pt',
    'qu',
    'rn',
    'ro',
    'ru',
    'rw',
    'sa',
    'sc',
    'sd',
    'se',
    'sg',
    'si',
    'sk',
    'sl',
    'sm',
    'sn',
    'so',
    'sq',
    'sr',
    'ss',
    'st',
    'su',
    'sv',
    'sw',
    'ta',
    'te',
    'tg',
    'th',
    'ti',
    'tk',
    'tl',
    'tn',
    'to',
    'tr',
    'ts',
    'tt',
    'tw',
    'ty',
    'ug',
    'uk',
    'ur',
    'uz',
    've',
    'vi',
    'vo',
    'wa',
    'wo',
    'xh',
    'yi',
    'yo',
    'za',
    'zh',
    'zu'
];

export const LANG_CODES = [
    'ca',
    'es',
    'en',
    'fr',
    'de',
    'it',
    'gl',
    'eu',
    'pt',
    'zh',
    'ja',
    'ru',
    'hi',
    'ar'
];
